import * as Yup from 'yup'

export const setupValidationSchema = () => (
  Yup.object().shape({
    username: Yup.string().required('Astute username is required'),
    password: Yup.string().required('Astute password is required'),
    passwordConfirmation: Yup.string()
     .oneOf([Yup.ref('password'), null], 'Passwords must match'),
  })
)

export const initialCredentialsFormValues = ({ username }) => ({
  username: username || '',
  password: '',
  passwordConfirmation: '',
})
